import Resume from './resume'
import Recommend from './recommend';
import User from './user'
import Position from './position'
import Offer from './offer'
import Business from './business';
import Comp from './comp'
import CandidateUI from './candidateUI'
import Candidate from './candidate'
import JobListUI from './jobListUI'
import Order from './order'

export interface IMobxState {
  resume: Resume;
  recommend:Recommend;
  user: User;
  position: Position;
  offer: Offer;
  business: Business;
  comp: Comp;
  candidateUI: CandidateUI;
  candidate: Candidate;
  jobListUI: JobListUI;
  order:Order;
}

export default {
  recommend:new Recommend(),
  resume: new Resume(),
  comp: new Comp(),
  user: new User(),
  position: new Position(),
  offer: new Offer(),
  business: new Business(),
  candidateUI: new CandidateUI(),
  candidate: new Candidate(),
  jobListUI: new JobListUI(),
  order: new Order()
}
